<template lang="pug">
  table.table.table-sm.table-bordered.table-striped.table-hover.table-align-middle.d-none(:id="tblId")
    thead.thead-light
      tr
        th.text-center(width="4%")
          span #
        th.text-nowrap(width="16%")
          span(:title="$t('ui.claim_date')") {{ $t('ui.claim_date') }}
        th.text-nowrap(width="12%")
          span(:title="$t('ui.account_id')") {{ $t('ui.account_id') }}
        th.text-nowrap(width="14%")
          span(:title="$t('ui.provider_list')") {{ $t('ui.provider_list') }}
        th.text-nowrap(width="15%")
          span(:title="$t('ui.remark')") {{ $t('ui.remark') }}
        th.text-right.text-nowrap(width="13%")
          span(:title="$t('ui.deposit_amount')") {{ $t("ui.deposit_amount") }}
        th.text-right.text-nowrap(width="13%")
          span(:title="$t('ui.bonus_amount')") {{ $t("ui.bonus_amount") }}
        th.text-right.text-nowrap(width="13%")
          span(:title="$t('ui.withdrawal_amount')") {{ $t("ui.withdrawal_amount") }}
    tbody.clusterize-content
      tr(v-if="tbl.length == 0")
        td(colspan="8").text-center
          span {{ $t('message.no_data_available') }}
      tr(v-for="(item, index) in tbl")
        td.text-center
          span(:title="index + 1") {{ index + 1 }}
        td
          span(:title="item.claim_date ? $moment(item.claim_date).format('YYYY-MM-DD HH:mm:ss') : ''") {{ item.claim_date ? $moment(item.claim_date).format('YYYY-MM-DD HH:mm:ss') : '' }}
        td
          span(:title="item.member_id || item.account_id") {{ item.member_id || item.account_id }}
        td
          template(v-if="item.provider_list")
            span(:title="item.provider_list") {{ item.provider_list }}
          template(v-else)
            span {{ $t('ui.all') }}
        td
          span(:title="item.remark") {{ item.remark }}
        td.text-right
          span.font-weight-bold(:title="$n(item.deposit_amount, 'currency')" :class="$helpers.fontClassName(item.deposit_amount)") {{ $n(item.deposit_amount, 'currency') }}
        td.text-right
          span.font-weight-bold(:title="$n(item.bonus_amount, 'currency')" :class="$helpers.fontClassName(item.bonus_amount)") {{ $n(item.bonus_amount, 'currency') }}
        td.text-right
          span.font-weight-bold(:title="$n(item.withdrawal_amount, 'currency')" :class="$helpers.fontClassName(item.withdrawal_amount)") {{ $n(item.withdrawal_amount, 'currency') }}
      tr.footer
        td.text-right(colspan="5")
          span {{ $t("ui.sub_total") }}
        td.text-right
          span.font-weight-bold(:class="$helpers.fontClassName(subTotalDepositAmountDetail)" :title="$n(subTotalDepositAmountDetail, 'currency')") {{ $n(subTotalDepositAmountDetail, 'currency') }}
        td.text-right
          span.font-weight-bold(:class="$helpers.fontClassName(subTotalBonusAmountDetail)" :title="$n(subTotalBonusAmountDetail, 'currency')") {{ $n(subTotalBonusAmountDetail, 'currency') }}
        td.text-right
          span.font-weight-bold(:class="$helpers.fontClassName(subTotalWithdrawalAmountDetail)" :title="$n(subTotalWithdrawalAmountDetail, 'currency')") {{ $n(subTotalWithdrawalAmountDetail, 'currency') }}
      tr.footer
        td.text-right(colspan="5")
          span {{ $t("ui.grand_total") }}
        td.text-right
          span.font-weight-bold(:class="$helpers.fontClassName(grandTotalDepositAmountDetail)" :title="$n(grandTotalDepositAmountDetail, 'currency')") {{ $n(grandTotalDepositAmountDetail, 'currency') }}
        td.text-right
          span.font-weight-bold(:class="$helpers.fontClassName(grandTotalBonusAmountDetail)" :title="$n(grandTotalBonusAmountDetail, 'currency')") {{ $n(grandTotalBonusAmountDetail, 'currency') }}
        td.text-right
          span.font-weight-bold(:class="$helpers.fontClassName(grandTotalWithdrawalAmountDetail)" :title="$n(grandTotalWithdrawalAmountDetail, 'currency')") {{ $n(grandTotalWithdrawalAmountDetail, 'currency') }}
</template>
<script>
export default {
  props: {
    tbl: {
      type: Array,
      default() {
        return []
      }
    },
    totalTbl: {
      type: Array,
      default() {
        return []
      }
    },
    tblId: {
      type: String,
      default: ""
    },
  },
  data: () => ({
    loading: false,
    subTotalDepositAmountDetail: 0,
    grandTotalDepositAmountDetail: 0,
    subTotalBonusAmountDetail: 0,
    grandTotalBonusAmountDetail: 0,
    subTotalWithdrawalAmountDetail: 0,
    grandTotalWithdrawalAmountDetail: 0,
  }),
  computed: {
    getPageSize() {
      return this.$store.getters.pageSize;
    },
    isOperator() {
      return [2].includes(this.$store.getters.accountType);
    },
    accountID() {
      return this.$store.getters.accountId;
    },
  },
  watch: {
    tbl() {
      this.getTotal();
    },
  },
  mounted: function() {
    this.getTotal();
  },
  methods: {
    clearTotal() {
      this.subTotalDepositAmountDetail = 0
      this.grandTotalDepositAmountDetail = 0
      this.subTotalBonusAmountDetail = 0
      this.grandTotalBonusAmountDetail = 0
      this.subTotalWithdrawalAmountDetail = 0
      this.grandTotalWithdrawalAmountDetail = 0
    },
    getTotal: function() {
      this.clearTotal();
      var tbl = this.tbl;
      if(tbl.length > 0) {
        tbl.forEach(value => {
          this.subTotalDepositAmountDetail = parseFloat(this.subTotalDepositAmountDetail) + parseFloat(value["deposit_amount"] || 0);
          this.subTotalBonusAmountDetail = parseFloat(this.subTotalBonusAmountDetail) + parseFloat(value["bonus_amount"] || 0);
          this.subTotalWithdrawalAmountDetail = parseFloat(this.subTotalWithdrawalAmountDetail) + parseFloat(value["withdrawal_amount"] || 0);
        });

        var totalTbl = this.totalTbl;
        if(totalTbl.length > 0) {
          this.grandTotalDepositAmountDetail = totalTbl[0]["deposit_amount"];
          this.grandTotalBonusAmountDetail = totalTbl[0]["bonus_amount"];
          this.grandTotalWithdrawalAmountDetail = totalTbl[0]["withdrawal_amount"];
        }
      }
    }
  }
};
</script>
